export const PAYMENT_API_RESPONSE_SEND = 'PAYMENT_API_RESPONSE_SEND';



// WEBPACK FOOTER //
// ./app/constants/premiumSubscriptionTypes.js